import { Link } from "react-router-dom";

const PolicySection = ({ number, title, children }) => (
  <section aria-labelledby={`privacy-section-${number}`} className="border-t border-[#0E1B31]/10 pt-9 sm:pt-11">
    <h2 id={`privacy-section-${number}`} className="font-display text-2xl sm:text-3xl font-semibold leading-snug text-[#0E1B31]">
      {number}. {title}
    </h2>
    <div className="mt-5 space-y-4 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">{children}</div>
  </section>
);

const PolicyList = ({ items }) => (
  <ul className="list-disc space-y-2 pl-6 marker:text-[#C26D52]">
    {items.map((item) => <li key={item}>{item}</li>)}
  </ul>
);

const PrivacyContact = () => (
  <p>
    Για ζητήματα σχετικά με την προστασία προσωπικών δεδομένων ή για την άσκηση των δικαιωμάτων σας, μπορείτε να επικοινωνήσετε με την CRESTIA μέσω της σελίδας <Link className="underline underline-offset-4 hover:text-[#0E1B31]" to="/contact">Επικοινωνία</Link>.
  </p>
);

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <header className="relative overflow-hidden mesh-hero grain pt-36 pb-16 lg:pt-44 lg:pb-20">
        <div className="perspective-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono-brand text-[11px] tracking-[0.28em] uppercase text-[#2C4A6F]">ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ</p>
          <h1 className="mt-7 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.06] text-[#0E1B31]">
            Πολιτική Απορρήτου
          </h1>
          <p className="mt-6 text-sm sm:text-base text-[#3B4A5E]">Τελευταία ενημέρωση: 27 Οκτωβρίου 2026</p>
        </div>
      </header>

      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24 space-y-11 sm:space-y-14" aria-label="Πολιτική Απορρήτου CRESTIA">
        <div className="space-y-5 text-[15px] sm:text-base leading-[1.8] text-[#3B4A5E]">
          <p>Η CRESTIA σέβεται την ιδιωτικότητα των επισκεπτών και χρηστών του ιστοτόπου της και δεσμεύεται να επεξεργάζεται τα προσωπικά δεδομένα με διαφάνεια, ασφάλεια και σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 («GDPR») και την εφαρμοστέα ελληνική νομοθεσία.</p>
          <p>Η παρούσα Πολιτική Απορρήτου εξηγεί ποια δεδομένα μπορεί να συλλέγονται μέσω του ιστοτόπου, για ποιους σκοπούς χρησιμοποιούνται, με ποια νομική βάση γίνεται η επεξεργασία και ποια δικαιώματα έχουν τα φυσικά πρόσωπα.</p>
        </div>

        <PolicySection number="1" title="Υπεύθυνος επεξεργασίας">
          <p>Υπεύθυνος επεξεργασίας για τα προσωπικά δεδομένα που συλλέγονται μέσω του παρόντος ιστοτόπου είναι η CRESTIA.</p>
          <PrivacyContact />
        </PolicySection>

        <PolicySection number="2" title="Ποια δεδομένα μπορεί να συλλέγουμε">
          <p>Ανάλογα με τον τρόπο με τον οποίο χρησιμοποιείτε τον ιστότοπο, μπορεί να επεξεργαζόμαστε δεδομένα όπως:</p>
          <PolicyList items={[
            "όνομα και επώνυμο",
            "διεύθυνση ηλεκτρονικού ταχυδρομείου",
            "αριθμό τηλεφώνου, όταν παρέχεται",
            "στοιχεία επικοινωνίας που καταχωρίζονται σε φόρμες",
            "περιεχόμενο μηνυμάτων ή αιτημάτων που μας αποστέλλετε",
            "πληροφορίες που παρέχετε οικειοθελώς κατά τη χρήση διαδραστικών ή AI λειτουργιών",
            "τεχνικά δεδομένα που είναι αναγκαία για τη λειτουργία και ασφάλεια του ιστοτόπου, όπως διεύθυνση IP, τύπος προγράμματος περιήγησης, λειτουργικό σύστημα και βασικά δεδομένα σύνδεσης, όπου αυτά πράγματι καταγράφονται από την υποδομή του ιστοτόπου",
            "μόνο μετά από συγκατάθεση για analytics, δεδομένα χρήσης όπως δημόσιες σελίδες που επισκέπτεστε, χρόνος χρήσης και τεχνικά στοιχεία browser ή συσκευής, καθώς και αναγνωριστικά των analytics cookies",
          ]} />
          <p>Δεν επιδιώκουμε να συλλέγουμε ειδικές κατηγορίες προσωπικών δεδομένων μέσω του ιστοτόπου.</p>
          <p>Οι χρήστες παρακαλούνται να μην καταχωρίζουν ευαίσθητα προσωπικά δεδομένα στις φόρμες, στο chat ή στις AI λειτουργίες του ιστοτόπου.</p>
        </PolicySection>

        <PolicySection number="3" title="Σκοποί επεξεργασίας">
          <p>Τα προσωπικά δεδομένα μπορεί να χρησιμοποιούνται για:</p>
          <PolicyList items={[
            "απάντηση σε ερωτήματα και αιτήματα επικοινωνίας",
            "παροχή πληροφοριών σχετικά με τις υπηρεσίες της CRESTIA",
            "διαχείριση αιτημάτων συνεργασίας",
            "λειτουργία των διαδραστικών εργαλείων του ιστοτόπου",
            "παροχή απαντήσεων μέσω AI λειτουργιών",
            "ασφάλεια και τεχνική λειτουργία του ιστοτόπου",
            "συμμόρφωση με νόμιμες υποχρεώσεις",
            "μέτρηση χρήσης και βελτίωση του ιστοτόπου μέσω Google Analytics 4, αποκλειστικά με τη συγκατάθεσή σας",
            "θεμελίωση, άσκηση ή υποστήριξη νομικών αξιώσεων όπου απαιτείται",
          ]} />
          <p>Δεν χρησιμοποιούμε προσωπικά δεδομένα για σκοπούς ασύμβατους με εκείνους για τους οποίους συλλέχθηκαν.</p>
        </PolicySection>

        <PolicySection number="4" title="Νομικές βάσεις επεξεργασίας">
          <p>Ανάλογα με την περίπτωση, η επεξεργασία μπορεί να βασίζεται:</p>
          <PolicyList items={[
            "στη συγκατάθεσή σας, όπου αυτή ζητείται",
            "στη λήψη μέτρων κατόπιν αιτήματός σας πριν από τη σύναψη σύμβασης",
            "στην εκτέλεση σύμβασης",
            "στη συμμόρφωση με έννομη υποχρέωση",
            "στο έννομο συμφέρον της CRESTIA για την επικοινωνία, ασφάλεια, εύρυθμη λειτουργία και προστασία των υπηρεσιών της, όταν το συμφέρον αυτό δεν υπερισχύεται από τα δικαιώματα και τις ελευθερίες του υποκειμένου των δεδομένων",
          ]} />
        </PolicySection>

        <PolicySection number="5" title="Επικοινωνία μέσω φορμών">
          <p>Όταν χρησιμοποιείτε φόρμα επικοινωνίας, επεξεργαζόμαστε τις πληροφορίες που παρέχετε αποκλειστικά για τη διαχείριση και απάντηση στο αίτημά σας και για τυχόν επόμενη επικοινωνία που σχετίζεται με αυτό.</p>
          <p>Παρακαλούμε να παρέχετε μόνο τις πληροφορίες που είναι αναγκαίες για το αίτημά σας.</p>
          <p>Αν έχετε αποδεχθεί τα analytics, μπορεί να καταγράφεται στο Google Analytics ένα συμβάν επιτυχούς υποβολής της φόρμας. Δεν αποστέλλονται σε αυτό όνομα, email, τηλέφωνο, εταιρεία, μήνυμα ή άλλα πεδία της φόρμας. Δεν καταγράφονται ως επιτυχείς οι αποτυχημένες ή μη ολοκληρωμένες υποβολές.</p>
        </PolicySection>

        <PolicySection number="6" title="AI και διαδραστικές λειτουργίες">
          <p>Ο ιστότοπος της CRESTIA μπορεί να περιλαμβάνει λειτουργίες τεχνητής νοημοσύνης, όπως ψηφιακό βοηθό, διαδραστικό chat ή εργαλεία ενδεικτικής επιχειρηματικής αξιολόγησης.</p>
          <p>Οι πληροφορίες που εισάγετε σε αυτές τις λειτουργίες μπορεί να υποβάλλονται σε επεξεργασία από τεχνολογικούς παρόχους που χρησιμοποιούνται για την παροχή της σχετικής υπηρεσίας.</p>
          <p>Ο ιστότοπος χρησιμοποιεί υπηρεσίες OpenAI για συγκεκριμένες AI λειτουργίες.</p>
          <p>Για τον λόγο αυτό:</p>
          <PolicyList items={[
            "μην καταχωρίζετε εμπιστευτικές πληροφορίες που δεν είναι αναγκαίες",
            "μην εισάγετε ειδικές κατηγορίες προσωπικών δεδομένων",
            "μην εισάγετε στοιχεία τρίτων χωρίς νόμιμη βάση",
          ]} />
          <p>Οι απαντήσεις που παράγονται από AI έχουν ενημερωτικό και ενδεικτικό χαρακτήρα και δεν υποκαθιστούν εξατομικευμένη επαγγελματική συμβουλή.</p>
        </PolicySection>

        <PolicySection number="7" title="Αποδέκτες και πάροχοι υπηρεσιών">
          <p>Προσωπικά δεδομένα μπορεί να είναι προσβάσιμα, στον βαθμό που είναι αναγκαίο, από παρόχους που υποστηρίζουν τη λειτουργία του ιστοτόπου και των υπηρεσιών του, όπως:</p>
          <PolicyList items={[
            "υπηρεσίες hosting και υποδομής",
            "τεχνικοί πάροχοι",
            "πάροχοι ηλεκτρονικού ταχυδρομείου",
            "πάροχοι AI υπηρεσιών",
          ]} />
          <p>Στον ιστότοπο χρησιμοποιούνται οι υπηρεσίες Google Fonts για γραμματοσειρές, Unsplash για εικόνες και OpenAI για συγκεκριμένες AI λειτουργίες.</p>
          <p>Μετά από αποδοχή των analytics χρησιμοποιείται επίσης το Google Analytics 4 της Google. Η υπηρεσία επεξεργάζεται δεδομένα χρήσης και τεχνικά αναγνωριστικά για στατιστική μέτρηση. Δεν ενεργοποιούμε διαφημιστική εξατομίκευση ή Google Signals. Περισσότερες πληροφορίες παρέχονται στην <a href="https://policies.google.com/privacy" className="underline underline-offset-4 hover:text-[#0E1B31]">Πολιτική Απορρήτου της Google</a>.</p>
        </PolicySection>

        <PolicySection number="8" title="Διαβιβάσεις εκτός Ευρωπαϊκού Οικονομικού Χώρου">
          <p>Ορισμένοι τεχνολογικοί πάροχοι ενδέχεται να επεξεργάζονται δεδομένα εκτός του Ευρωπαϊκού Οικονομικού Χώρου.</p>
          <p>Όπου απαιτείται, οι σχετικές διαβιβάσεις πρέπει να βασίζονται σε κατάλληλους μηχανισμούς προστασίας σύμφωνα με τον GDPR, όπως αποφάσεις επάρκειας ή εγκεκριμένες τυποποιημένες συμβατικές ρήτρες.</p>
        </PolicySection>

        <PolicySection number="9" title="Χρόνος διατήρησης">
          <p>Τα προσωπικά δεδομένα διατηρούνται μόνο για όσο χρονικό διάστημα είναι αναγκαίο για τον σκοπό για τον οποίο συλλέχθηκαν.</p>
          <p>Η τοπική επιλογή συγκατάθεσης και τα analytics cookies έχουν διάρκεια έως 180 ημέρες. Η διατήρηση δεδομένων που έχουν ήδη αποσταλεί στο Google Analytics διέπεται από τις ρυθμίσεις διατήρησης της υπηρεσίας και είναι διαφορετική από τη διάρκεια των cookies.</p>
          <p>Ενδεικτικά:</p>
          <PolicyList items={[
            "αιτήματα επικοινωνίας διατηρούνται για όσο είναι αναγκαίο για τη διαχείριση του αιτήματος και τυχόν σχετική επαγγελματική επικοινωνία",
            "δεδομένα που απαιτούνται για νομικούς ή λογιστικούς λόγους μπορεί να διατηρούνται για το χρονικό διάστημα που προβλέπει η νομοθεσία",
            "τεχνικά δεδομένα ασφάλειας μπορεί να διατηρούνται για περιορισμένο χρονικό διάστημα για την προστασία της υποδομής",
          ]} />
          <p>Όταν η διατήρηση δεν είναι πλέον αναγκαία, τα δεδομένα διαγράφονται ή ανωνυμοποιούνται, όπου αυτό είναι εφικτό.</p>
        </PolicySection>

        <PolicySection number="10" title="Cookies και παρόμοιες τεχνολογίες">
          <p>Ο ιστότοπος ενδέχεται να χρησιμοποιεί cookies ή άλλες παρόμοιες τεχνολογίες για τη λειτουργία του.</p>
          <p>Τα προαιρετικά analytics παραμένουν ανενεργά μέχρι την αποδοχή σας. Από τις «Ρυθμίσεις cookies» στο footer μπορείτε να απορρίψετε ή να ανακαλέσετε τη συγκατάθεση οποτεδήποτε, χωρίς να στερείστε τις υπόλοιπες λειτουργίες του ιστοτόπου.</p>
          <p>Για αναλυτικές πληροφορίες σχετικά με τις τεχνολογίες που χρησιμοποιούνται, τον σκοπό τους και τις διαθέσιμες επιλογές διαχείρισης, παρακαλούμε ανατρέξτε στην <Link className="underline underline-offset-4 hover:text-[#0E1B31]" to="/cookies">Πολιτική Cookies</Link>.</p>
        </PolicySection>

        <PolicySection number="11" title="Δικαιώματα των υποκειμένων των δεδομένων">
          <p>Σύμφωνα με τον GDPR, και υπό τις προϋποθέσεις που προβλέπονται από τη νομοθεσία, έχετε δικαίωμα:</p>
          <PolicyList items={[
            "πρόσβασης στα προσωπικά δεδομένα που σας αφορούν",
            "διόρθωσης ανακριβών ή ελλιπών δεδομένων",
            "διαγραφής δεδομένων",
            "περιορισμού της επεξεργασίας",
            "εναντίωσης στην επεξεργασία",
            "φορητότητας των δεδομένων, όπου εφαρμόζεται",
            "ανάκλησης της συγκατάθεσης οποτεδήποτε, όταν η επεξεργασία βασίζεται σε συγκατάθεση",
          ]} />
          <p>Η ανάκληση της συγκατάθεσης δεν επηρεάζει τη νομιμότητα της επεξεργασίας που πραγματοποιήθηκε πριν από την ανάκλησή της.</p>
          <PrivacyContact />
        </PolicySection>

        <PolicySection number="12" title="Δικαίωμα καταγγελίας">
          <p>Εάν θεωρείτε ότι η επεξεργασία των προσωπικών δεδομένων σας παραβιάζει την ισχύουσα νομοθεσία, έχετε δικαίωμα να υποβάλετε καταγγελία στην:</p>
          <p>Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (ΑΠΔΠΧ)</p>
        </PolicySection>

        <PolicySection number="13" title="Ασφάλεια δεδομένων">
          <p>Λαμβάνονται κατάλληλα τεχνικά και οργανωτικά μέτρα με στόχο την προστασία των προσωπικών δεδομένων από μη εξουσιοδοτημένη πρόσβαση, απώλεια, αλλοίωση, δημοσιοποίηση ή καταστροφή.</p>
          <p>Ωστόσο, καμία μετάδοση ή αποθήκευση δεδομένων μέσω διαδικτύου δεν μπορεί να θεωρηθεί απολύτως ασφαλής.</p>
        </PolicySection>

        <PolicySection number="14" title="Σύνδεσμοι προς τρίτους">
          <p>Ο ιστότοπος μπορεί να περιέχει συνδέσμους προς ιστοτόπους ή υπηρεσίες τρίτων.</p>
          <p>Η CRESTIA δεν ελέγχει τις πρακτικές απορρήτου τρίτων ιστοτόπων και οι χρήστες καλούνται να εξετάζουν τις αντίστοιχες πολιτικές απορρήτου.</p>
        </PolicySection>

        <PolicySection number="15" title="Αλλαγές στην Πολιτική Απορρήτου">
          <p>Η παρούσα Πολιτική μπορεί να τροποποιείται όταν αλλάζουν οι υπηρεσίες, οι τεχνολογίες που χρησιμοποιούνται ή οι σχετικές νομικές απαιτήσεις.</p>
          <p>Η εκάστοτε ισχύουσα έκδοση θα δημοσιεύεται στην παρούσα σελίδα και θα αναγράφει την ημερομηνία τελευταίας ενημέρωσης.</p>
        </PolicySection>

        <PolicySection number="16" title="Επικοινωνία">
          <PrivacyContact />
        </PolicySection>
      </article>
    </div>
  );
}
